// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BusinessRiskSchema = z.enum(['OPERATIONAL_DISRUPTION','CRITICAL_SYSTEM_SHUTDOWN','THEFT_OF_IP','REGULATORY_BREACH','FINANCIAL_LOSS','REPUTATIONAL_DAMAGE'] as const);

export type BusinessRiskType = `${z.infer<typeof BusinessRiskSchema>}`

export default BusinessRiskSchema;
